import { render } from "./SigninBody.vue?vue&type=template&id=6b62f6ef&scoped=true"
import script from "./SigninBody.vue?vue&type=script&lang=js"
export * from "./SigninBody.vue?vue&type=script&lang=js"

import "./SigninBody.vue?vue&type=style&index=0&id=6b62f6ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b62f6ef"]])

export default __exports__